/**
 * Copy we render INSTEAD of the tenant's own wording, keyed by `/booking/form` paragraph code.
 *
 * This is a deliberate exception to the rule that all form copy comes from the booking system so
 * the client can reword it without a deploy (see docs/ARCHITECTURE.md §1.4). Anything listed here
 * can no longer be changed in the booking system's admin — an edit there will silently do nothing,
 * because this wins. Keep the list short, and delete an entry to hand the wording back.
 *
 * Requested by the client 2026-09-09: the recurring-cleanings blurb, replacing
 * "How frequently would you like your car cleaned?".
 */
export const PARAGRAPH_OVERRIDES: Readonly<Record<string, string>> = {
  schedule_information:
    'No contracts, reschedule easily online, cancel completely with 30 days notice!',
};

/**
 * Section headings we word ourselves, keyed by `/booking/form` heading code. Rendered
 * uppercase by the stylesheet, so the case here is not what the customer sees.
 *
 * Requested by the client 2026-09-09: `custom_fields_section`, the tenant's "ADDITIONAL INFO".
 */
export const HEADING_OVERRIDES: Readonly<Record<string, string>> = {
  custom_fields_section: 'Your Vehicle',
};

/** The override for a paragraph code, or null when we defer to the tenant. */
export function paragraphOverride(code: string): string | null {
  return PARAGRAPH_OVERRIDES[code] ?? null;
}

/** The override for a heading code, or null when we defer to the tenant. */
export function headingOverride(code: string): string | null {
  return HEADING_OVERRIDES[code] ?? null;
}
